'use strict';

const Dialog = require('../../lib/dialog').default;
const util = require('../../utils/util');
const progress = require('../../utils/progress');

function removeBodyScroll() {
    $('body').addClass('overflow-hidden');
}

function returnBodyScroll() {
    $('body').removeClass('overflow-hidden');
}

function openZoomDesktop(html, index) {
    const dialog = new Dialog({
        additionalClasses: ['product-zoom-image'],
        useLegacyBackdrop: false,
        html: html,
        isModal: false,
        useLegacyContainer: true,
        canCloseOnBackdropClick: false,
        hasTitleBar: true,
        callback: () => {
            progress.show($('body'));
            $('body').addClass('full-opacity');
            removeBodyScroll();
            const $container = $('#dialog-container');
            const $image = $('#dialog-container').find('#zoom-product-image-' + index);
            const imageSrc = $('#dialog-container').find('#zoom-product-image-' + index + ' > img');
            function srcImgLoaded() {
                let imgTop = $image.offset().top;
                let offsetTop = $container.offset().top;
                let scrollTop = $container.scrollTop();
                let elementScroll = scrollTop + imgTop - offsetTop;
                $container.animate(
                    {
                        scrollTop: elementScroll
                    },
                    0
                );
                progress.hide();
                $('body').removeClass('full-opacity');
            }
            let imgLoaded = imageSrc[0];
            if (imgLoaded.complete) {
                srcImgLoaded();
            } else {
                imgLoaded.addEventListener('load', srcImgLoaded);
            }
        },
        closeCallback: () => {
            returnBodyScroll();
        }
    });
    dialog.open();
}
exports.init = function () {
    var $pdpMain = $('#pdpMain');

    $pdpMain.on('click keypress', '.product-image-slick  .grid-tile.thumb .zoom-icon', function (event) {
        if (util.isClickOrSpaceOrEnter(event)) {
            var data = $(this).data();
            var index = data.index;
            var html = '';
            var windowWidth = $(window).width();
            var windowHeight = $(window).height();

            if (util.isMobile() && windowHeight * 2 > windowWidth) {
                var imgUrl = data.img;
                var imgTitle = data.title;
                var imgAlt = data.alt;
                var $image = '<img src="' + imgUrl + '" title="' + imgTitle + '" alt="' + imgAlt + '"/>';
                $('.zoom-product-images.mobile').find('.zoom-placeholder').html('').append($image);
                html = $('.zoom-product-images.mobile').html();

                const dialog = new Dialog({
                    additionalClasses: ['product-zoom-image'],
                    useLegacyBackdrop: false,
                    html: html,
                    isModal: false,
                    useLegacyContainer: true,
                    canCloseOnBackdropClick: false,
                    hasTitleBar: true,
                    callback: () => {
                        removeBodyScroll();
                        const $wrapper = $('.product-zoom-image .ui-dialog-content');
                        const $img = $('.product-zoom-image .zoom-placeholder > img');
                        let scrollTo = ($img.width() - $wrapper.width()) / 2;
                        $wrapper.animate(
                            {
                                scrollLeft: scrollTo
                            },
                            0
                        );
                    },
                    closeCallback: () => {
                        returnBodyScroll();
                    }
                });
                dialog.open();
            } else {
                if ($('.zoom-product-images.desktop').hasClass('loaded')) {
                    html = $('.zoom-product-images.desktop').html();
                    openZoomDesktop(html, index);
                } else {
                    $.ajax({
                        url: util.appendParamsToUrl(Urls.initProductZoom, {pid: data.pid, color: data.color})
                    }).done(function (html) {
                        openZoomDesktop(html, index);
                        $('.zoom-product-images.desktop').html(html);
                        $('.zoom-product-images.desktop').addClass('loaded');
                    });
                }
            }
        }
    });
};
